import { Paper, Table, Text } from '@mantine/core';
import type { PatientNutritionMetrics } from '../types';
import { formatMetricValue } from '../utils/formatters';

interface NutritionMetricsTableProps {
  metrics: PatientNutritionMetrics;
}

export function NutritionMetricsTable({
  metrics,
}: NutritionMetricsTableProps) {
  if (metrics.rows.length === 0) {
    return (
      <Paper withBorder p='xl'>
        <Text size='sm' c='dimmed'>
          Inserisci le misure corporee per ottenere la tabella tecnica.
        </Text>
      </Paper>
    );
  }

  return (
    <Paper withBorder p='md'>
      <Table striped>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Metrica</Table.Th>
            <Table.Th>Formula / criterio</Table.Th>
            <Table.Th>Valore</Table.Th>
            <Table.Th>Unità</Table.Th>
            <Table.Th>Interpretazione</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {metrics.rows.map(row => (
            <Table.Tr key={row.key}>
              <Table.Td>{row.label}</Table.Td>
              <Table.Td>{row.formula}</Table.Td>
              <Table.Td>{formatMetricValue(row.value, { decimals: 3 })}</Table.Td>
              <Table.Td>{row.unit}</Table.Td>
              <Table.Td>{row.interpretation ?? '-'}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}
